import { useContext, useEffect, useState } from "react";
import { PitchContext } from "../context/PitchContex";

const SearchBar = () => {
  const [filteredCities, setFilteredCities] = useState([]);
  const { setCity, setDistrict, search, setSearch } = useContext(PitchContext);

  function capitalizeWordTurkish(str) {
    if (!str || typeof str !== "string") return "";

    // Handle Turkish 'i' and 'I' specifically
    const firstChar = str.charAt(0);
    const rest = str.slice(1);

    // Map Turkish lowercase 'i' to 'İ' and 'ı' to 'I'
    const turkishMap = {
      i: "İ",
      ı: "I",
      u: "U",
      ü: "Ü",
      o: "O",
      ö: "Ö",
      s: "S",
      ş: "Ş",
      c: "C",
      ç: "Ç",
      g: "G",
      ğ: "Ğ",
    };

    const upperFirst =
      turkishMap[firstChar] || firstChar.toLocaleUpperCase("tr-TR");
    const lowerRest = rest.toLocaleLowerCase("tr-TR");

    return upperFirst + lowerRest;
  }

  const handleSearchChange = (e) => {
    const value = capitalizeWordTurkish(e.target.value);
    setSearch(value);

    if (value) {
      const filtered = turkiyeCities.filter((city) =>
        city.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCities(filtered);
    } else {
      setFilteredCities([]);
    }
  };

  const handleCitySelect = (city) => {
    setSearch(city);
    const cityAndDistrict = city.split(" ");
    setCity(cityAndDistrict[0]);
    setDistrict(cityAndDistrict[1] || ""); // Handle cases where there's no district
    setFilteredCities([]);
  };

  return (
    <div className="relative w-80 sm:w-full max-w-md">
      <input
        type="text"
        placeholder="İl veya ilçe ara..."
        value={search}
        onChange={handleSearchChange}
        className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-300 text-gray-700 placeholder-gray-400"
      />
    </div>
  );
};

export default SearchBar;
